import Media from "./Media";

export default class ContentGroup {
  uploadedAt: string;
  contentGroupId: string;
  name: string;
  groupType: string;
  isAutoUpdate: boolean;
  contentGroup: Media[];
  id: string;
  thumb: string;

  constructor(
    uploadedAt: string,
    contentGroupId: string,
    name: string,
    groupType: string,
    isAutoUpdate: boolean,
    contentGroup: Media[],
    id: string,
    thumb: string
  ) {
    this.uploadedAt = uploadedAt;
    this.contentGroupId = contentGroupId;
    this.name = name;
    this.groupType = groupType;
    this.isAutoUpdate = isAutoUpdate;
    this.contentGroup = contentGroup;
    this.id = id;
    this.thumb = thumb;
  }

  static fromObject(obj: {
    uploadedAt: string;
    contentGroupId: string;
    name: string;
    groupType: string;
    isAutoUpdate: boolean;
    contentGroup: [];
    id: string;
    thumb: string;
  }) {
    const mediaGroup: Media[] = [];
    obj.contentGroup.forEach((media) => {
      mediaGroup.push(Media.fromObject(media));
    });

    return new ContentGroup(
      obj.uploadedAt,
      obj.contentGroupId,
      obj.name,
      obj.groupType,
      obj.isAutoUpdate,
      mediaGroup,
      obj.id,
      obj.thumb
    );
  }

  getGroup() {
	  return this.contentGroup;
  }

  setSrc() {
	  return null;
  }

  setDuration() {
	  return null;
  }
}
